import { Fragment, useContext, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import AuthContext from "../../AuthContext";
import {toast} from 'react-toastify'
import  UploadImage from '../UploadImage'
import MultipleImage from '../MultipleUpload'
import axios from "axios";
import axiosInstance from '../../axios'
import MultiSelect from "../Dropdowns/MultiSelect";
import MultiSectors from '../Dropdowns/MultiSectors'
import UserName from '../Dropdowns/Username'
import District from '../Dropdowns/District'
import State from '../Dropdowns/States'
export default function AddProduct({
  addProductModalSetting,
  handlePageUpdate,
}) {
  const authContext = useContext(AuthContext);
  const[err,setErr]=useState(false)
  const [image,setImage]=useState([])
  const[profile,setProfile]=useState('')
  const[document,setDocument]=useState('')
  const[agreement,setAgreement]=useState('')
  const[receipt,setReceipt]=useState('')
  const[cheque,setCheque]=useState('')
  const[cid,setCid]=useState('')
  const imp=true
  const[state,setState]=useState('')
  const [district,setDistrict]=useState('')
  const[deposite,setDeposite]=useState('')
  const[guarantee,setGurantee]=useState('')
  const [centre, setCentre] = useState({
    status:1,
    centrename: "",
    sip_id: "",
    vtpid: "",
    address:"",
    pmkvypartner:'',
    landmark:"",
    tahsil:"",
    district:"",
    category:"",
    state:"",
    city:"",
    pincode:'',
    panno:"",
    tanno:'',
    cpid:"",
  cpname:" ",
  cpmob:"",
  cpemail:"",
  cpaddress:'',
  bankname:"",
  bbranch:"",
  bifsc:'',
  baccno:'',
  fyear:'',

});
const [selectedScheme, setSelectedScheme] = useState([]);
const[selectedSectors,setSelectedSectors]=useState([])

  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setCentre(prevState => ({
    ...prevState,
    [name]: value
  }));
};
const [isButtonDisabled, setIsButtonDisabled] = useState(false);

const [cname, setCname] = useState('');
const [cemail, setCemail] = useState('');
const [contact, setContact] = useState('');
const handleCid = async (e) => {
  const selectedCid = e.target.value;
  setCid(selectedCid);

  try {
    const response = await axiosInstance.post('/users/getAdminDetails', {
      user_id: selectedCid
    });

    // Assuming the response data structure as given
    if (response.data.user && response.data.user.length > 0) {
      const userData = response.data.user[0]; // Get the first (and possibly only) user object
      setCname(userData.full_name);
      setCemail(userData.email);
      setContact(userData.phone_no);
      // Assuming cpaddress refers to some other field, you might update it similarly
      // setCpaddress(userData.some_other_field);
    } else {
      console.log('No user data found');
      // Handle the case where no user data is returned
    }
  } catch (error) {
  toast.error('Error fetching admin details:', error);
    // Handle error, e.g., show an error message to the user
  }
};
const resetForm = () => {
  setCentre({
    centrename: '',
    sip_id: '',
    vtpid: '',
    address: '',
    landmark: '',
    tahsil: '',
    district: '',
    state: '',
    city: '',
    pmkvypartner: '',
    pincode: '',
    panno: '',
    tanno: '',
    cpaddress: '',
    bankname: '',
    bbranch: '',
    bifsc: '',
    baccno: '',
    fyear: '',
    category: '',
    status:1
  });
  setDocument(null);
  setProfile(null);
  setReceipt(null);
  setCheque(null);
  setDeposite(null);
  setGurantee(null);
  setAgreement(null);
  setImage([]);
  setSelectedScheme('');
  setSelectedSectors('')
  setCid('');
  setCname('');
  setContact('');
  setCemail('');
  setState('')
  setDistrict('')
  setIsButtonDisabled(true); // Disable button to prevent multiple submissions
};
const handleSchemeChange = (newSelectedScheme) => {
  setSelectedScheme(newSelectedScheme);
};
const handleSectorsChange=(newSelectedSectors)=>{
  setSelectedSectors(newSelectedSectors)
}
const handleImagesChange = (newImages) => {
  setImage(newImages);
};
const handleProfileChange = (e) => {
  setProfile(e.target.files[0]);
};
const handleReciept=(e)=>{
  setReceipt(e.target.files[0]);
}
const handleDocumentChange = (e) => {
  setDocument(e.target.files[0]);
};
const handleAgreementChange = (e) => {
  setAgreement(e.target.files[0]);
};
const handleChequeChange = (e) => {
  setCheque(e.target.files[0]);
};
const handleDepositeChange = (e) => {
  setDeposite(e.target.files[0]);
};
const handleGuaranteeChange = (e) => {
  setGurantee(e.target.files[0]);
};


const addCentre = () => {
// Validation
setIsButtonDisabled(true); 

const requiredFields = {
  "Centre Name": centre.centrename,
  "SIP No": centre.sip_id,
  "VTP ID": centre.vtpid,
  "Address": centre.address,
  "State": state,
  "Tahsil": centre.tahsil,
  "District": district,
  "City": centre.city,
  "Pincode": centre.pincode,
  "PAN No": centre.panno,
  "TAN No": centre.tanno,
  "CID": cid,
  "Contact Person Address": centre.cpaddress,
  "Bank Name": centre.bankname,
  "Bank Branch": centre.bbranch,
  "Bank IFSC": centre.bifsc,
  "Bank Account No": centre.baccno,
  "Financial Year": centre.fyear,
  "Document": document,
  "Profile": profile,
  "Receipt": receipt,
  "Cheque": cheque,
  "Selected Scheme": selectedScheme
};
const missingFields = Object.keys(requiredFields).filter(key => {
  const field = requiredFields[key];
  return !field || (Array.isArray(field) && field.length === 0);
});

if (missingFields.length > 0) {
  toast.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
  setIsButtonDisabled(false)

  return;
}

  // Create FormData
  const formData = new FormData();
  formData.append('centre_name', centre.centrename);
  formData.append('vtp_no', centre.sip_id);
  formData.append('vtp_id', centre.vtpid);
  formData.append('centre_address', centre.address);
  formData.append('landmark', centre.landmark);
  formData.append('tahsil', centre.tahsil);
  formData.append('district', district);
  formData.append('state', state);
  formData.append('city', centre.city);
  formData.append('pmkvy_partner', centre.pmkvypartner);
  formData.append('pin_code', centre.pincode);
  formData.append('pan_no', centre.panno);
  formData.append('tan_no', centre.tanno);
  formData.append('cp_id', cid);
  formData.append('cp_name', cname);
  formData.append('cp_mo_no', contact);
  formData.append('cp_email', cemail);
  formData.append('cp_address', centre.cpaddress);
  formData.append('bank_name', centre.bankname);
  formData.append('branch', centre.bbranch);
  formData.append('ifsc_code', centre.bifsc);
  formData.append('bank_acc_no', centre.baccno);
  formData.append('financial_year', centre.fyear);
  formData.append('centre_category', centre.category);
  formData.append('documents', document);
  formData.append('cp_profile_image', profile);
  formData.append('receipt_file', receipt);
  formData.append('cheque_file', cheque);
  formData.append('deposit_file', deposite);
  formData.append('guarantee_file', guarantee);
  formData.append('agreement_file', agreement);
  formData.append('scheme_id', selectedScheme);
  formData.append('sector_name',selectedSectors)
  formData.append('centre_status',centre.status||1)
  for (let i = 0; i < image.length; i++) {
      formData.append('centre_images', image[i]);
  }

  // API call
  axiosInstance.post('trainingcentre/insert', formData)
      .then((result) => {
          toast.success("Centre Added Successfully");
          handlePageUpdate();
          resetForm()
          //addProductModalSetting();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.error) {
          if (err.response.data.error.includes('Duplicate entry')) {
              toast.error("VTP ID already exists");
          }
      }
        if(err.response.data.error){
          toast.error("Error Adding Centre");
          console.log(err)
        }

      })
      .finally(() => {
        setIsButtonDisabled(false); // Re-enable the button after toast is displayed
      });
      ;

  setErr(false);
};
  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg
               bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-5xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Add Centre
                      </Dialog.Title>
                      <form action="#" aria-autocomplete="true" >
                        <div className="grid gap-4 mb-4 sm:grid-cols-5" > 
                          <div>
                            <label
                           className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                            >Centre Images</label>
                            <MultipleImage onImagesChange={handleImagesChange} />
                          </div>

                          <div>
                            <label
                              htmlFor="centrename"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Centre Name<span className='text-red-500'> *</span>
                            </label>
                            <input
                            type="text"
                            name="centrename"
                            id="centrename"
                            value={centre.centrename}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                          </div>
                          <div>
                            <label
                              htmlFor="sip_id"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                          SIP ID <span className='text-red-500'> *</span>
                            </label>
                            <input
                              type="text"
                              name="sip_id"
                              id="sip_id"
                              value={centre.sip_id}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                           <div>
                            <label
                              for="vtpid"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                            VTP  ID<span className='text-red-500'> *</span>
                            </label>
                            <input
                              type="text"
                              id="vtpid"
                              name="vtpid"
                              value={centre.vtpid}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                          <div>
                            <label
                              for="category"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                            >
                              Category 
                            </label>
                            <input
                              type="text"
                              name="category"
                              id="category"
                              value={centre.category}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            
                            />
                          </div>
                         

                          <div>
                          <label htmlFor="pmkvypartner" 
                                                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
>
            Partner Agency<span className='text-red-500'> *</span>
          </label>
          <input
            type="text"
            id="pmkvypartner"
            name="pmkvypartner"
            value={centre.pmkvypartner}
            onChange={handleInputChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                            </div>
                            <div>
                              <label
                                htmlFor="address"
                                                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                              >
                                Address<span className='text-red-500'> *</span>
                              </label>
                              <input
                                type="text"
                                id="address"
                                name="address"
                                value={centre.address}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                aria-autocomplete="true"
                              />
                            </div>
                            <div>
                            <State handleChange={e=>setState(e.target.value)} value={state} imp={imp}/>
                            </div>
                            <div>
                              <District selectedState={state} 
                              handleChange={e=>setDistrict(e.target.value)} 
                              value={district} imp={imp}/>
                            </div>
                            <div>
                              <label htmlFor="city"
                                                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                               >
                                City<span className='text-red-500'> *</span>
                               </label>
                               <input type="text"
                              id="city"
                              name="city"
                              value={centre.city}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                              :focus:border-blue-500"
                              />
                            </div>
                            
                            <div>
                              <label htmlFor="pincode"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"

                              >Pincode <span className='text-red-500'> *</span></label>
                              <input type="text"
                              id="pincode"
                              name="pincode"
                              value={centre.pincode}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                              :focus:border-blue-500"
                              />
                            </div>
                            <div>
                              <label htmlFor="landmark"                               
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >Landmark</label>
                              <input
                              type="text"
                              id="landmark"
                              name="landmark"
                              value={centre.landmark}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                              :focus:border-blue-500"
                              />
                            </div>
                            <div>
                            <label
                              htmlFor="tahsil"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Tahsil<span className='text-red-500'> *</span>
                            </label>
                            <input 
                            type="text"
                            name="tahsil"
                            id="tahsil"
                            value={centre.tahsil}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                        
                            <div>
                            <label
                              htmlFor="panno"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Pan No.<span className='text-red-500'> *</span>
                            </label>
                            <input
                            type="text"
                            name="panno"
                            id="panno"
                            value={centre.panno}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label
                              htmlFor="tanno"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Tan No.<span className='text-red-500'> *</span>
                            </label>
                            <input 
                            type="text"
                            name="tanno"
                            id="tanno"
                            value={centre.tanno}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                            <div>
                          <label
                          htmlFor="contactperson"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >Contact Person Photo <span className='text-red-500'> *</span></label>
                          <UploadImage uploadImage={handleProfileChange} fileName={profile}/>
                              </div>
                              <div>
                                <UserName value={cid} handleInputChange={handleCid} imp={imp} />
                            
                              
                          </div>
                          <div>
                                <label htmlFor="cname" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contact Person Name</label>
                                <input
                                type="text"
                                id="cname"
                                name="cname"
                                value={cname}
                                disabled
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>

                            
                              
                          </div>
                          <div>
                                <label htmlFor="contact"  
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  Contact Person Mobile</label>
                                <input
                                type="text"
                                id="contact"
                                name="contact"
                                value={contact}
                                disabled
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>

                            
                              
                          </div>
                          <div>
                                <label htmlFor="cemail" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contact Person Email</label>
                                <input
                               type="text"
                                id="cemail"
                                name="cemail"
                                value={cemail}
                               disabled
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>

                            
                              
                          </div>
                          <div>
                                <label htmlFor="cpaddress" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contact Person Address</label>
                                <input
                                type="text"
                                id="cpaddress"
                                name="cpaddress"
                                value={centre.cpaddress}
                                onChange={handleInputChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>

                            
                              
                          </div>
                          <div>
                            <label htmlFor="bankname"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Name <span className='text-red-500'> *</span></label>
                            <input
                            type="text"
                            name="bankname"
                            id="bankname"
                            value={centre.bname}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="baccno"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Account No.<span className='text-red-500'> *</span></label>
                            <input
                            type="text"
                            name="baccno"
                            id="baccno"
                            value={centre.baccno}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="bifsc"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank IFSC <span className='text-red-500'> *</span></label>
                            <input
                            type="text"
                            name="bifsc"
                            id="bifsc"
                            value={centre.bifsc}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="bbranch"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Branch <span className='text-red-500'> *</span></label>
                            <input
                            type="text"
                            name="bbranch"
                            id="bbranch"
                            value={centre.bbranch}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="recipt"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Receipt <span className='text-red-500'> *</span></label>
                            <label
        htmlFor="recipt"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {receipt?.name && receipt.name.length > 8
            ? receipt.name.substring(0, 8) + "..."
            : receipt?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="recipt"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleReciept}
      />
                          </div>
                          <div>
                            <label htmlFor="document"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Documents <span className='text-red-500'> *</span></label>
                            <label
        htmlFor="document"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {document?.name && document.name.length > 8
            ? document.name.substring(0, 8) + "..."
            : document?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="document"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleDocumentChange}
      />
                          </div>
                          <div>
                            <label htmlFor="agreement"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Agreement <span className='text-red-500'> *</span></label>
                           <label
        htmlFor="agreement"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {agreement?.name && agreement.name.length > 8
            ? agreement.name.substring(0, 8) + "..."
            : agreement?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="agreement"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleAgreementChange}
      />
                          </div>
                         
                          <div>
                            <label htmlFor="cheque"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Cancelled Cheque <span className='text-red-500'> *</span></label>
                           <label
        htmlFor="cheque"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {cheque?.name && cheque.name.length > 8
            ? cheque.name.substring(0, 8) + "..."
            : cheque?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="cheque"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleChequeChange}
      />
                          </div>
                          <div>
                            <label htmlFor="deposite"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Deposit</label>
                          <label
        htmlFor="deposite"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {deposite?.name && deposite.name.length > 8
            ? deposite.name.substring(0, 8) + "..."
            : deposite?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="deposite"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleDepositeChange}
      />
                          </div>
                          <div>
                            <label htmlFor="guarantee"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Guarantee</label>
                           <label
        htmlFor="guarantee"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {guarantee?.name && guarantee.name.length > 8
            ? guarantee.name.substring(0, 8) + "..."
            : guarantee?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="guarantee"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleGuaranteeChange}
      />
                          </div>
      
               
                                             
                          <div className="col-span-1 lg:col-span-2 row-span-5">
    <MultiSelect
      selectedCourses={selectedScheme}
      onChange={handleSchemeChange}
      isDisabled={false}
      imp={imp}
    />
  </div>
  <div className="col-span-1 lg:col-span-2 row-span-5">
    <MultiSectors
      selectedCourses={selectedSectors}
      onChange={handleSectorsChange}
      isDisabled={false}
      imp={imp}
    />
  </div>
                                        
                        <div>
                            <label htmlFor="fyear"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Financial Year <span className='text-red-500'> *</span></label>
                            <input
                            type="text"
                            name="fyear"
                            id="fyear"
                            value={centre.fyear}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                                </div>
                                <div className="flex items-center space-x-4">
                              {/*  <button
                                    type="submit"
                                    className="text-white bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                  >
                                    Update
                                  </button> 
                                <button
                                    type="button"
                                    className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                                  >
                                    <svg
                                      className="mr-1 -ml-1 w-5 h-5"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                        clip-rule="evenodd"
                                      ></path>
                                    </svg>
                                    Delete
                                  </button>*/}
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                          <button
                             className={`inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto 
                              ${isButtonDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-500'}`}
                              onClick={addCentre}
                              disabled={isButtonDisabled}
                          >
                          {isButtonDisabled ? 'Adding...' : 'Add Centre'}
                          </button>
                          <button
                            type="button"
                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            onClick={() => addProductModalSetting()}
                            ref={cancelButtonRef}
                          >
                            Cancel
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
          );
        }
